<div mdbModal #saveAndFinishModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
     aria-hidden="true">
  <div class="modal-dialog" role="document">
    <form (ngSubmit)="saveAndFinishLater()" #saveAndFinishLaterForm="ngForm" novalidate>
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close pull-right" aria-label="Close" (click)="close()">
            <span aria-hidden="true">×</span>
          </button>
          <h4 class="modal-title w-100" id="myModalLabel">Save and Finish Later</h4>
        </div>
        <div class="modal-body">
          To save your job application, enter the required information and click the "Finish Later" button. You will receive an email with a link to your saved application.
          <br />
          <br />
          Please note that you must complete all required fields on any given page of the application in order to save this page of your job application. Failure to do so will delete any/all partial content.
          <br />
          <br />
          <div class="col-12">
            <div class="form-group">
              <label for="finishLaterEmailAddress" class="required">
                Email Address
              </label>
              <input mdbInput mdbValidate type="text" class="form-control" id="finishLaterEmailAddress" name="finishLaterEmailAddress" placeholder="Enter Email Address" required appAutofocus
                     [(ngModel)]="emailAddress" #emailAddressInput="ngModel" [pattern]="emailRegex" />
              <div *ngIf="emailAddressInput.invalid && (emailAddressInput.dirty || emailAddressInput.touched)" class="invalid-feedback" style="display: block;">
                <div *ngIf="emailAddressInput.errors.required">
                  Email Address is required
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label for="confirmFinishLaterEmailAddress" class="required">
                Confirm Email Address
              </label>
              <input mdbInput mdbValidate type="text" class="form-control" id="confirmFinishLaterEmailAddress" name="confirmFinishLaterEmailAddress" placeholder="Confirm Email Address" required
                     [(ngModel)]="confirmEmailAddress" #confirmEmailAddressInput="ngModel" [pattern]="emailRegex" />
              <div *ngIf="confirmEmailAddressInput.invalid && (confirmEmailAddressInput.dirty || confirmEmailAddressInput.touched)" class="invalid-feedback" style="display: block;">
                <div *ngIf="confirmEmailAddressInput.errors.required">
                  Confirm Email Address is required
                </div>
              </div>
              <div *ngIf="emailAddress.toLowerCase() !== confirmEmailAddress.toLowerCase()" class="invalid-feedback" style="display: block;">
                Confirm Email Address must match Email Address
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary" mdbWavesEffect
                  [disabled]="!saveAndFinishLaterForm.form.valid || emailAddress.toLowerCase() !== confirmEmailAddress.toLowerCase()">
            <i class="fa fa-spinner fa-spin" aria-hidden="true" *ngIf="saving"></i>Save And Finish Later
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
